import TimeAgo from "react-timeago";
import { useFirestore } from "react-redux-firebase";
import Moment from "react-moment";
import {
  typeColorCondition,
  contactTypeArray,
} from "../contact-details/constants";
import styled from "styled-components";
import ContactMobile from "./mobile/ContactMobile";
import { useState } from "react";
import { ChatCircleText } from "phosphor-react";

const Holder = styled.div`
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  font-size: 1rem;
  background: ${({ customer }) => (customer ? "var(--primary)" : "white")};
  border-radius: 5px;
  padding: 15px 10px;
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;
  border: 1px solid ${({ color }) => color};
  * {
    color: ${({ customer }) => (customer ? "white" : "grey")};
    font-weight: ${({ customer }) => (customer ? "700" : "300")};
  }

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 900px) {
    display: block;
  }
`;

const Name = styled.div`
  width: ${({ customer }) => (customer ? "40%" : "30%")};
  font-weight: ${({ customer }) => (customer ? "900" : "700")};
  color: ${({ customer }) => (customer ? "white" : "var(--primary)")};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const Info = styled.div`
  min-width: 30%;
  font-weight: 500;
  padding-right: 5px;
`;

const Phone = styled.div`
  font-size: 0.65rem;
`;

const Email = styled.div`
  font-size: 0.6rem;
  a {
  }
`;

const Time = styled.div`
  font-size: 0.75rem;
  min-width: 20%;
  color: grey;
`;

const Date = styled.div`
  font-style: italic;
  font-size: 0.6rem;
`;

const Ago = styled.div``;

const Type = styled.div`
  font-size: 0.65rem;
  display: flex;
  align-items: center;
  width: 20%;
  span {
    font-weight: 800;
  }
`;

const Circle = styled.div`
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  border-color: ${({ color }) => color};
  background-color: rgba(0, 0, 0, 0);
  margin-right: 5px;
`;

const Modal = styled.div`
  position: absolute;
  color: grey;
  z-index: 999;
  top: 0;
  left: ${({ customer }) => (customer ? "unset" : "-51%")};
  right: ${({ customer }) => (!customer ? "unset" : "-51%")};
  width: 50%;
  font-size: 0.85em;
`;

const ModalDesc = styled.div`
  background: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 20px;
  border-radius: 5px;
  border: 2px solid ${({ color }) => color};
`;

const ModalComment = styled.div`
  padding: 10px;
  background: white;
  border-radius: 5px;
  /* color: white; */
  margin-top: 5px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border: 2px solid white;
  display: flex;
  align-items: flex-start;
  svg {
    margin-right: 10px;
    min-width: 20px;
    min-height: 20px;
  }
`;

function Contact({ contact, whenContactClicked, customer, comments }) {
  const firestore = useFirestore();
  
  const {
    firstName,
    lastName,
    phoneNumber,
    email,
    contactType,
    id,
    createdTime,
    description,
  } = contact;

  const handleClickContactType = () => {
    let typeIndex = contactTypeArray.indexOf(contactType);

    return firestore.update(
      { collection: "contacts", doc: id },
      {
        contactType:
          contactTypeArray[(typeIndex + 1) % contactTypeArray.length],
      }
    );
  };

  const [descModal, setDescModal] = useState(false);

  return (
    <Holder>
      {descModal && (
        <Modal customer={contactType === "customer"}>
          <ModalDesc color={typeColorCondition[contactType]}>
            "{description}"
          </ModalDesc>
          {comments.map((comment, i) => (
            <ModalComment key={i}>
              <ChatCircleText weight="fill" />
              {comment.commentBody}
            </ModalComment>
          ))}
        </Modal>
      )}
      <Container
        color={typeColorCondition[contactType]}
        customer={customer}
        onMouseOver={() => setDescModal(true)}
        onMouseLeave={() => setDescModal(false)}
      >
        <Name onClick={() => whenContactClicked(id)} customer={customer}>
          {(firstName + lastName).length ? `${firstName} ${lastName}` : "_"}
        </Name>
        <Info>
          <Phone>{phoneNumber}</Phone>

          <Email>
            <a
              href={`mailto:${email.toLowerCase()}?subject=Smiling Woods`}
              rel="noreferrer"
              target="_blank"
            >
              {email.toLowerCase()}
            </a>
          </Email>
        </Info>

        <Time>
          <Ago>
            <TimeAgo date={createdTime} />
          </Ago>
          <Date>
            <Moment date={createdTime} format="MMMM D, 'YY" />
          </Date>
        </Time>
        {!customer && (
          <Type onClick={handleClickContactType}>
            <Circle color={typeColorCondition[contactType]}></Circle>
            <span style={{ color: typeColorCondition[contactType] }}>
              {contactType.toUpperCase()}
            </span>
          </Type>
        )}
      </Container>
      <Mobile>
        <ContactMobile
          contact={contact}
          customer={customer}
          whenContactClicked={whenContactClicked}
        />
      </Mobile>
    </Holder>
  );
}

export default Contact;
